import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
// import * as AWS from 'aws-sdk'
// const IDENTITY_POOL_ID = 'eu-west-2:9c052296-b683-4fe1-a205-9f4d89bafa41'
const USER_POOL_ID = 'eu-west-2_chYFmFWAP'
const CLIENT_ID = '11u0bf545urperp4ig57l8occ7'

const UserPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: USER_POOL_ID,
  ClientId: CLIENT_ID
})

export function isLoggedIn (yes, no) {
  let cognitoUser = UserPool.getCurrentUser()
  console.log('cognitoUser', cognitoUser)
  if (cognitoUser !== null) {
    cognitoUser.getSession((err, session) => {
      if (err) {
        console.log('err', err)
        no()
      }
      if (session.isValid()) {
        yes()
      } else {
        console.log('session.isValid = false')
        no()
      }
    })
  } else {
    console.log('cognitoUser is null')
    no()
  }
}

export function logOut () {
  UserPool.getCurrentUser().signOut()
}

export function requireAuth (to, from, next) {
  isLoggedIn(() => {
    next()
  }, () => {
    console.log('not logged in?')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  })
}



// WEBPACK FOOTER //
// ./src/auth.js